export default __webpack_public_path__ + "static/media/image26.82914bb1.svg";